import React, { useState, useEffect } from "react";
import { Modal, ModalHeader, ModalBody, ModalFooter, Button, FormGroup, Label, Input } from "reactstrap";
import { showErrorAlert, showSuccessAlert } from "../../../../components/custom/sweetalertHelper";

const MetaAdsModal = ({ isOpen, toggle, currentConfig, onSubmit }) => {
    const [formData, setFormData] = useState({});

    useEffect(() => {
        if (currentConfig) {
            setFormData({
                name: currentConfig.name,
                expireDate: currentConfig.expireDate,
                appSecret: currentConfig.metaData.appSecret || '',
                accessToken: currentConfig.metaData.accessToken || '',
                appId: currentConfig.metaData.appId || '',
            });
        } else {
            resetFormData();
        }
    }, [currentConfig]);

    const resetFormData = () => {
        setFormData({
            name: '',
            expireDate: '',
            appSecret: '',
            accessToken: '',
            appId: ''
        });
    };

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData({ ...formData, [name]: value });
    };

    const handleSubmit = () => {
        const today = new Date();
        const expireDate = new Date(formData.expireDate);

        if (!formData.expireDate || expireDate <= today || isNaN(expireDate.getTime())) {
            showErrorAlert("Invalid Date", "Please enter a valid expiration date that is later than today.");
            return;  
        }
        onSubmit(formData);
        toggle();  
    };

    return (
        <Modal isOpen={isOpen} toggle={toggle}>
            <ModalHeader toggle={toggle}>{currentConfig ? 'Edit Meta Ads Account' : 'Create Meta Ads Account'}</ModalHeader>
            <ModalBody>
                <FormGroup>
                    <Label for="name">Name</Label>
                    <Input type="text" name="name" id="name" value={formData.name} onChange={handleInputChange}  placeholder="Enter Name" />
                </FormGroup>
                <FormGroup>
                    <Label for="expireDate">Expire Date</Label>
                    <Input type="date" name="expireDate" id="expireDate" value={formData.expireDate} onChange={handleInputChange} />
                </FormGroup>
                <FormGroup>
                    <Label for="appId">App ID</Label>
                    <Input 
                        type="text" 
                        name="appId" 
                        id="appId" 
                        value={formData.appId} 
                        onChange={handleInputChange}
                        placeholder="Enter Meta App ID"
                    />
                </FormGroup>
                <FormGroup>
                    <Label for="appSecret">App Secret</Label>
                    <Input type="text" name="appSecret" id="appSecret" value={formData.appSecret} onChange={handleInputChange}  placeholder="Enter Meta App Secret"/>
                </FormGroup>
                <FormGroup>
                    <Label for="accessToken">Access Token</Label>
                    <Input type="text" name="accessToken" id="accessToken" value={formData.accessToken} onChange={handleInputChange}  placeholder="Enter Meta Access Token"/>
                </FormGroup>
            </ModalBody>
            <ModalFooter>
                <Button color="secondary" onClick={toggle}>Cancel</Button>
                <Button color="success" onClick={handleSubmit}>Submit</Button>
            </ModalFooter>
        </Modal>
    );
};

export default MetaAdsModal;
